import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SalesDetailsComponent } from './sales-details/sales-details.component';

const salesRoutes: Routes = [{ path: 'sales/:cnpj/:id', component: SalesDetailsComponent }];

@NgModule({
  imports: [RouterModule.forChild(salesRoutes)],
  exports: [RouterModule],
})
export class SalesRoutingModule {}
